import { RequestToSummaryAccessStatus } from '@dreryk/egabinet-visit-frontend-api';

export const requestToSummaryAccessStatusVisitor = (status: RequestToSummaryAccessStatus | undefined) => <
   ACCEPT
>(visitor: {
   none: () => ACCEPT;
   pending: () => ACCEPT;
   accepted: () => ACCEPT;
}): ACCEPT => {
   if (!status) {
      return visitor.none();
   }

   if (status === 'PENDING') {
      return visitor.pending();
   }

   return visitor.accepted();
};
